import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set. Copy .env.example to .env.",
  );
}

/**
 * The browser only ever holds the publishable (anon) key. It grants nothing
 * by itself — `anon` has no table grants and no policy targets it. Every read
 * and write is authorised by RLS against the signed-in user's JWT.
 *
 * The service-role key must never reach the browser.
 */
export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Microsoft sign-in returns through a redirect; the client must pick
    // the PKCE code out of the URL when the browser lands back here.
    detectSessionInUrl: true,
    flowType: "pkce",
  },
  db: { schema: "public" },
  global: { headers: { "x-application-name": "viewpoint-core-web" } },
});
